import request from 'api/request';

export default function deleteShiftRoute(id) {
  return request({ url: `/shifts/${id}`, method: 'DELETE' });
}
